import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import {
  AbstractControl,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { BaseStyleClassesDirective } from '../../gk-directives';
import { CaseSelectControlName } from './services/case-select-form/case-select-form.model';
import { CaseSelectService } from './services/case-select/case-select.service';

@Component({
  selector: 'gk-case-select',
  imports: [
    CommonModule,
    MatSelectModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  template: `
    <form [formGroup]="formGroup">
      @let caseSelectFormControlAlertShouldBeVisible =
        submitted && !isCaseFormControlValid();
      <section>
        <div
          class="card mb-4"
          [ngClass]="
            caseSelectFormControlAlertShouldBeVisible
              ? 'border-danger border-2'
              : 'card-border-color-from-db'
          "
        >
          <div class="card-header card-header-color-from-db">
            <label class="mb-0" [attr.for]="controlName.CaseUuid">
              {{ 'CASE_SELECT.TITLE' | translate }}
            </label>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <mat-select
                  class="form-select form-select-sm required"
                  [id]="controlName.CaseUuid"
                  [attr.name]="controlName.CaseUuid"
                  [formControlName]="controlName.CaseUuid"
                  [placeholder]="'CASE_SELECT.CHOOSE_CASE' | translate"
                >
                  @for (
                    caseSelect of caseSelectService.get(url) | async;
                    track caseSelect.id
                  ) {
                    <mat-option [value]="caseSelect.id">
                      {{ caseSelect.name }}
                    </mat-option>
                  }
                </mat-select>
              </div>
            </div>
          </div>
          @if (caseSelectFormControlAlertShouldBeVisible) {
            <div class="card-footer">
              <div class="alert alert-danger my-2">
                {{ 'FIELD_REQUIRED' | translate }}
              </div>
            </div>
          }
        </div>
      </section>
    </form>
  `,
})
export class CaseSelectComponent extends BaseStyleClassesDirective {
  @Input() submitted: boolean;
  @Input() url: string;
  @Input() formGroup: FormGroup;
  controlName = CaseSelectControlName;

  constructor(public caseSelectService: CaseSelectService) {
    super();
  }

  isCaseFormControlValid(): boolean {
    return this.getCaseFormControl().valid;
  }

  getCaseFormControl(): AbstractControl {
    return this.formGroup.get(this.controlName.CaseUuid);
  }
}
